var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentVerifyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flat_Color",
    "data-name": "Flat Color"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29 9.83v17.17a2 2 0 0 1 -2 2h-16a2 2 0 0 1 -2-2v-22a2 2 0 0 1 2-2h11.17a2 2 0 0 1 1.42.59l4.82 4.82a2 2 0 0 1 .59 1.42z",
    fill: "#f2f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 9.83v.17h-5a2 2 0 0 1 -2-2v-5h.17a2 2 0 0 1 1.42.59l4.82 4.82a2 2 0 0 1 .59 1.42z",
    fill: "#e1dedd"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0b4f6c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18 10.75h-3a.75.75 0 0 1 0-1.5h3a.75.75 0 0 1 0 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 14.75h-5a.75.75 0 0 1 0-1.5h5a.75.75 0 0 1 0 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 18.75h-4a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 0 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 22.75h-5a.75.75 0 0 1 0-1.5h5a.75.75 0 0 1 0 1.5z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 19,
    fill: "#20bf55",
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.38 21.31a.75.75 0 0 1 -.54-.22l-1.84-1.87a.75.75 0 0 1 0-1.06.74.74 0 0 1 1.06 0l1.32 1.34 2.62-2.59a.74.74 0 0 1 1.06 0 .75.75 0 0 1 -.06 1.09l-3.09 3.09a.74.74 0 0 1 -.53.22z",
    fill: "#f2f1f1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentVerifyIcon);
export default __webpack_public_path__ + "static/media/document-verify-icon.f0b8a0974bac49ebf39277464fede2a6.svg";
export { ForwardRef as ReactComponent };